import CheckBoxWithLabel from "./CheckBoxWithLabel";

interface CheckboxMapProps {
  options: string[];
  className?: string;
  handelCheckBox?: (id: string) => void;
  checkedArray: string[];
  disabledCheckBox?: string[];
}

const CheckboxMap = ({
  options,
  className,
  handelCheckBox,
  checkedArray,
  disabledCheckBox
}: CheckboxMapProps) => {
  return (
    <div className={`flex pr-2 ${className}`}>
      {options.map((arrayItem) => (
        <div className="w-full" key={arrayItem}>
          <CheckBoxWithLabel
            key={arrayItem}
            label={arrayItem}
            disabled={disabledCheckBox?.includes(arrayItem)}
            handelCheckBox={handelCheckBox}
            checked={checkedArray.includes(arrayItem)}
          />
        </div>
      ))}
    </div>
  );
};

export default CheckboxMap;
